import './jquery.doubletaptogo.min';
import { NAVIGATION, CROSS_BREAKPOINT } from '../breakpoint-controller';

const MOBILE = 'mobile';
const DESKTOP = 'desktop';
const DOUBLE_TAP_SELECTOR =
    '#main-menu .menu-item-top-level.menu-item-has-children';
const exitDelay = 250;
const enterDelay = 150;

let scrollY = 0;
let mode = MOBILE;
let open = false;

let body = null;
let mainMenu = null;
let activeItem = null;
let exitTimeout = null;
let enterTimeout = null;
let itemToOpen = null;

var $ = window.jQuery;

function onDocumentReady() {
    $(document).on(CROSS_BREAKPOINT, onCrossBreakpoint);
    body = $(document.body);
    mainMenu = $('#main-menu');

    $('#main-menu-toggle').on('click', onClickMobileNavToggle);
    $(mainMenu).on('click', '.sub-menu-toggle', onClickSubMenuToggle);
}

function onClickSubMenuToggle(e) {
    let clicked = $(e.currentTarget);
    let item = clicked.closest('.menu-item');

    clicked.toggleClass('active');
    item.children('.sub-menu').slideToggle();
}

function onClickMobileNavToggle(e) {
    if (open) {
        closeMobileNav();
    } else {
        openMobileNav();
    }
}

function openMobileNav() {
    mainMenu.stop(true, true).show();
    scrollY = $(window).scrollTop();
    body
        .addClass('nav-open')
        .addClass('noscroll')
        .css({ top: -1 * scrollY });

    open = true;
}

function closeMobileNav() {
    mainMenu.stop(true, true).hide();
    body.removeClass('nav-open').removeClass('noscroll');
    $(window).scrollTop(scrollY);

    open = false;
}

function reset() {
    mainMenu.removeAttr('style');
    mainMenu.find('.menu-item-top-level').removeClass('active');
    mainMenu.find('.sub-menu').removeAttr('style');
    mainMenu.find('.sub-menu-toggle').removeClass('active');
    body.removeClass('nav-open').removeClass('noscroll');
    open = false;
}

function setMode(newMode) {
    if (newMode === mode) {
        return false;
    }

    mode = newMode;
    reset();

    switch (mode) {
        case MOBILE:
            mainMenu
                .off(
                    'mouseenter',
                    '.menu-item-top-level',
                    onMouseEnterTopLevelItem
                )
                .off(
                    'mouseleave',
                    '.menu-item-top-level',
                    onMouseLeaveTopLevelItem
                );

            $(DOUBLE_TAP_SELECTOR).doubleTapToGo('unbind');
            break;

        case DESKTOP:
            mainMenu
                .on(
                    'mouseenter',
                    '.menu-item-top-level',
                    onMouseEnterTopLevelItem
                )
                .on(
                    'mouseleave',
                    '.menu-item-top-level',
                    onMouseLeaveTopLevelItem
                );

            $(DOUBLE_TAP_SELECTOR).doubleTapToGo();

            break;
    }
}

function onMouseEnterTopLevelItem(e) {
    itemToOpen = $(e.currentTarget);

    clearTimeout(exitTimeout);
    clearTimeout(enterTimeout);
    enterTimeout = setTimeout(finishMouseEnterTopLevelItem, enterDelay);
}

function finishMouseEnterTopLevelItem() {
    setActiveItem(itemToOpen);
}

function onMouseLeaveTopLevelItem(e) {
    clearTimeout(exitTimeout);
    clearTimeout(enterTimeout);
    exitTimeout = setTimeout(clearActiveItem, exitDelay);
}

function clearActiveItem() {
    setActiveItem(null);
}

function setActiveItem(item) {
    if (item && activeItem && item.get(0) === activeItem.get(0)) {
        return false;
    }

    if (activeItem) {
        deactivateMenuItem(activeItem);
    }
    if (item) {
        activateMenuItem(item);
    } else {
        activeItem = null;
    }
}

function activateMenuItem(item) {
    item.addClass('menu-active');
    item
        .children('.sub-menu')
        .stop(true, false);
    activeItem = item;
}

function deactivateMenuItem(item) {
    item.removeClass('menu-active');
    item
        .children('.sub-menu')
        .stop(true, false);
}

function onCrossBreakpoint(e, breakpoint) {
    if (breakpoint >= NAVIGATION) {
        setMode(DESKTOP);
    } else {
        setMode(MOBILE);
    }
}

document.addEventListener('DOMContentLoaded', onDocumentReady);



// WEBPACK FOOTER //
// ./wp-content/themes/synergy/assets/scripts/source/vpm/nav-controller.js